import * as React from 'react';
import { useZustand } from 'use-zustand';
import { widgetStore } from '../store';
import { DeveloperWallImages, DeveloperWallImageEditor, Actions, BeforeAndAfter, Preloader } from '../partials';

const finalImageSelectedState = () => 3;

async function updateSelectedImage(id, payload, errorsSetter) {
  const options = {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  };
  const response = await fetch(`/nv/admin/developer_wall_generated_images/${id}.json`, options);
  if (response.ok === false) {
    let collectedErrors = []
    const {errors} = await response.json();
    console.log(errors);
    for (const key in errors) {
      while (errors[key].length) {
        const e = errors[key].pop();
        console.log(e);
        collectedErrors.push(e);
      }
    }
    errorsSetter(collectedErrors);
  }
}

async function updateSubmission(id, payload) {
  const options = {
    method: 'PATCH',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  };
  const response = await fetch(`/nv/admin/developer_wall_submissions/${id}.json`, options);
}

function approveHandler(selectedImageID, submissionId, selectedImageURL, updateErrors) {
  if (!confirm('This action is irreversible. Do you want to continue?')) {
    return;
  }

  updateSelectedImage(selectedImageID, {selected: true}, updateErrors)
    .then(() => updateSubmission(submissionId, {status: finalImageSelectedState()}))
    .then(() => {
      location.reload()
    });
}

function BeforeAndAfterActions(props) {
  const {
    submissionId
  } = props;

  const selectedImageID = useZustand(widgetStore, state => state.selectedImageID);
  const selectedImageURL = useZustand(widgetStore, state => state.selectedImageURL);

  const updateErrors = useZustand(widgetStore, state => state.updateErrors);

  const onClickApproveHandler = () => approveHandler(selectedImageID, submissionId, selectedImageURL, updateErrors);

  return (
    <div className='thumbnail__controls'>
      <button type='button' onClick={onClickApproveHandler}>
        Approve
      </button>
    </div>
  );
}

function EmptyMessage() {
  return <p>Nothing here yet — image previews will be shown once generated.</p>;
}

export function ViewMode() {
  const status = useZustand(widgetStore, (state) => state.status);
  const images = useZustand(widgetStore, (state) => state.images);
  switch (status) {
    case 'images_generated':
    case 'approved':
      return <DeveloperWallImages/>;
    case 'final_image_selected':
      return <BeforeAndAfter/>
    default:
      return <EmptyMessage/>;
  }
}

export function EditMode(props) {
  const {submissionId} = props;
  const status = useZustand(widgetStore, (state) => state.status);
  const images = useZustand(widgetStore, (state) => state.images);

  switch (status) {
    case 'submitted':
      return (
        <>
          <BeforeAndAfter/>
        </>
      );
    case 'approved':
      return (
        <>
          <Actions submissionId={submissionId} hasImages={images && images.length > 0}/>
          <DeveloperWallImageEditor/>
          <BeforeAndAfter/>
        </>
      );
    case 'generating_images':
      return <Preloader/>;
    case 'images_generated':
      return (
        <>
          <Actions submissionId={submissionId} hasImages={images && images.length > 0}/>
          <DeveloperWallImageEditor/>
          <BeforeAndAfter>
            <BeforeAndAfterActions submissionId={submissionId}/>
          </BeforeAndAfter>
        </>
      );
    case 'final_image_selected':
      return (
        <>
          <BeforeAndAfter/>
        </>
      );

    default:
      return <EmptyMessage/>;
  }
}
